export default __webpack_public_path__ + "static/media/Ailsa.12501f81.png";